import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListTokenAuthIdCell } from '@app/feature/transaction/transaction-list/transaction-list-token-auth-id.cell';
import { TransactionListTokenAuthIdHeader } from '@app/feature/transaction/transaction-list/transaction-list-token-auth-id.header';

export const ChargePointChannelTransactionListTokenAuthIdColumn: IdentifiedColumnDef<
  TransactionModel,
  NonNullable<TransactionModel['token']>['authId'] | undefined
> = {
  id: 'tokenAuthId',
  enableSorting: false,
  header: TransactionListTokenAuthIdHeader,
  cell: TransactionListTokenAuthIdCell,
};
